'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoGitPullRequest = function GoGitPullRequest(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.5 28.2v-15.7s-3.7-7.5-7.5-7.5h-2.5v-5l-7.5 7.5 7.5 7.5v-5h2.5s2.5 1.3 2.5 2.5v15.7c-1.5 0.9-2.5 2.5-2.5 4.3 0 2.8 2.2 5 5 5s5-2.2 5-5c0-1.8-1-3.4-2.5-4.3z m-2.5 6.8c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z m-20-32.5c-2.8 0-5 2.2-5 5 0 1.8 1 3.4 2.5 4.3v16.4c-1.5 0.8-2.5 2.4-2.5 4.3 0 2.7 2.2 5 5 5s5-2.3 5-5c0-1.9-1-3.5-2.5-4.3v-16.4c1.5-0.9 2.5-2.5 2.5-4.3 0-2.8-2.2-5-5-5z m0 32.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z m0-25c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z' })
        )
    );
};

exports.default = GoGitPullRequest;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/git-pull-request.js
// module id = 1722
// module chunks = 0